__turbopack_context__.v({
  "divider": "AllMembers-module-scss-module__1ROFLW__divider",
  "memberBorder": "AllMembers-module-scss-module__1ROFLW__memberBorder",
  "members": "AllMembers-module-scss-module__1ROFLW__members",
  "root": "AllMembers-module-scss-module__1ROFLW__root",
  "searchBar": "AllMembers-module-scss-module__1ROFLW__searchBar",
  "searchInput": "AllMembers-module-scss-module__1ROFLW__searchInput",
  "title": "AllMembers-module-scss-module__1ROFLW__title",
});
